import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR };

export const SET_FILTERED_AND_SORTED_SITE_MONITORINGS =
	"SET_FILTERED_AND_SORTED_SITE_MONITORINGS";
export const SET_SITE_MONITORINGS = "SET_SITE_MONITORINGS";
export const SET_SITE_MONITORING_FILTERS = "SET_SITE_MONITORING_FILTERS";

export const SET_CURRENT_SITE_MONITORING = "SET_CURRENT_SITE_MONITORING";
export const SET_EXPANDED_LOT_ID = "SET_EXPANDED_LOT_ID";
export const SET_SITE_MONITORING_SELECTED_TAB = "SET_SITE_MONITORING_SELECTED_TAB";

export const SET_FILTERED_AND_SORTED_NOTES = "SET_FILTERED_AND_SORTED_NOTES";
export const SET_EDITING_NOTE = "SET_EDITING_NOTE";
export const SET_NOTES_FILTERS = "SET_NOTES_FILTERS";
export const SET_NOTES = "SET_NOTES";
export const SET_NB_ALL_NOTES = "SET_NB_ALL_NOTES";

export const SET_LOTS = "SET_LOTS";

export const SET_ALL_TAGS = "SET_ALL_TAGS";

export const SET_PLANS = "SET_PLANS";
export const SET_EXPANDED_PLAN_ID = "SET_EXPANDED_PLAN_ID";

export const SET_NOTE_COMMENTS = "SET_NOTE_COMMENTS";

export const MANAGER_ROLE = "manager";
export const READER_ROLE = "reader";
export const USER_ROLE = "user";

export const ROLES = [
	MANAGER_ROLE,
	READER_ROLE,
	USER_ROLE
]

export const DETAILS_TAB_INDEX = 0;
export const STRUCTURE_TAB_INDEX = 1;
export const PLANS_TAB_INDEX = 2
export const NOTES_TAB_INDEX = 3;
export const REPORT_TAB_INDEX = 4;
export const SETTINGS_TAB_INDEX = 5;